module.exports = __webpack_public_path__ + "img/monkey-king.fbfbfce5.png";